"use client";

import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

type ImageCarouselProps = {
  images: string[];
};

const ImageCarousel = (props: ImageCarouselProps) => {
  const { images } = props;

  const [current, setCurrent] = useState(0);

  const nextImage = () => setCurrent((prev) => (prev + 1) % images.length);

  const prevImage = () => setCurrent((prev) => (prev - 1) % images.length);

  return (
    <div className="relative h-28 w-48">
      <img src={images[current]} alt="carousel" className="h-full w-full object-cover object-center" />
      <button
        className="absolute left-2 top-1/2 h-5 w-5 -translate-y-1/2 transform rounded-full bg-transparent bg-white focus:outline-none"
        onClick={prevImage}
      >
        <FontAwesomeIcon icon={faAngleLeft} />
      </button>
      <button
        className="absolute right-2 top-1/2 h-5 w-5 -translate-y-1/2 transform rounded-full bg-transparent bg-white focus:outline-none"
        onClick={nextImage}
      >
        <FontAwesomeIcon icon={faAngleRight} />
      </button>
      <div className="absolute bottom-2 left-1/2 flex -translate-x-1/2 transform space-x-2">
        {images.map((_, index) => (
          <div
            key={index}
            className={`h-1.5 w-1.5 rounded-full shadow-imageCarousel ${current === index ? "bg-attention" : "border"}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;
